import React from "react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import { Link } from "react-router-dom";
import Icon from "../../components/AppIcon";
import interviews from "../../data/interviews";
import LazyYouTube from "./LazyYouTube";

const AuthorInterviews = () => {
    const getYouTubeId = (url) => {
        const match = url.match(/(?:v=|\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : null;
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="mb-8">
                    <Link
                        to="/homepage-literary-universe-hub"
                        className="inline-flex items-center text-primary hover:text-accent"
                    >
                        <Icon name="ArrowLeft" size={16} className="mr-2" />
                        Volver al inicio
                    </Link>
                </div>

                <section className="text-center mb-10">
                    <h1 className="font-headline text-3xl md:text-4xl font-bold text-primary mb-3">
                        Entrevistas de la Autora
                    </h1>
                    <p className="font-body text-scholarly-gray text-base md:text-lg max-w-2xl mx-auto">
                        Disfruta de las entrevistas más destacadas de la Dra. Rosa María Cifuentes,
                        donde comparte su experiencia, conocimiento y reflexiones sobre diversos temas
                        espirituales, psicológicos y humanos.
                    </p>
                </section>

                {/* Sección de entrevistas por año */}
                <section className="space-y-12">
                    {Object.keys(interviews)
                        .sort((a, b) => b - a)
                        .map((year) => (
                            <div key={year}>
                                <h2 className="text-2xl font-bold text-primary mb-6 border-b-2 border-primary/30 inline-block">
                                    {year}
                                </h2>

                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                                    {interviews[year].map((url, index) => {
                                        const videoId = getYouTubeId(url);
                                        return (
                                            <div
                                                key={index}
                                                className="relative aspect-video rounded-lg overflow-hidden literary-shadow hover:literary-shadow-elevated literary-transition"
                                            >
                                                <LazyYouTube
                                                    videoId={videoId}
                                                    title={`Entrevista ${year} - ${index + 1}`}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default AuthorInterviews;
